// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: tick-data.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Candle } from "./candle-data-depot-common";
import { TimeBucket } from "./common";
import { CompanyEventProto } from "./company_event";
import { CorporateAction } from "./corporate-action";
import { NewsArticle } from "./market_news";
import { Security } from "./security";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.tickdata";

export interface GetCandlesBulkRequest {
  requests: GetCandlesRequest[];
}

export interface GetCandlesBulkRequestV2 {
  requests: GetCandlesRequestV2[];
}

export interface GetCandlesRequest {
  security: Security | undefined;
  timeBucket: TimeBucket | undefined;
  referenceTime: number;
  nextToken: string;
  numberOfCandles: number;
  dontGiveExtraCandles: boolean;
}

export interface GetCandlesRequestV2 {
  security: Security | undefined;
  timeBucket: TimeBucket | undefined;
  referenceTime: number;
  forwardCandleCount: number;
  backwardCandleCount: number;
  dontGiveExtraCandles: boolean;
  dontApplyCorporateActionAdjustments: boolean;
}

export interface GetCandlesBulkResponse {
  responses: GetCandlesResponse[];
}

export interface GetCandlesBulkResponseV2 {
  responses: GetCandlesResponseV2[];
}

export interface GetCandlesResponse {
  security: Security | undefined;
  timeBucket: TimeBucket | undefined;
  referenceTime: number;
  candles: Candle[];
  nextToken: string;
  referencedSecurities: Security[];
}

export interface GetCandlesResponseV2 {
  security: Security | undefined;
  timeBucket: TimeBucket | undefined;
  forwardCandles: Candle[];
  backwardCandles: Candle[];
  lastCandleStoreUpdateTime: number;
  referencedSecurities: Security[];
  corporateActions: CorporateAction[];
  companyEvents: CompanyEventProto[];
  newsArticles: NewsArticle[];
}

function createBaseGetCandlesBulkRequest(): GetCandlesBulkRequest {
  return { requests: [] };
}

export const GetCandlesBulkRequest = {
  encode(message: GetCandlesBulkRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.requests) {
      GetCandlesRequest.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesBulkRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesBulkRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requests.push(GetCandlesRequest.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesBulkRequest {
    return {
      requests: globalThis.Array.isArray(object?.requests)
        ? object.requests.map((e: any) => GetCandlesRequest.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCandlesBulkRequest): unknown {
    const obj: any = {};
    if (message.requests?.length) {
      obj.requests = message.requests.map((e) => GetCandlesRequest.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesBulkRequest>, I>>(base?: I): GetCandlesBulkRequest {
    return GetCandlesBulkRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesBulkRequest>, I>>(object: I): GetCandlesBulkRequest {
    const message = createBaseGetCandlesBulkRequest();
    message.requests = object.requests?.map((e) => GetCandlesRequest.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCandlesBulkRequestV2(): GetCandlesBulkRequestV2 {
  return { requests: [] };
}

export const GetCandlesBulkRequestV2 = {
  encode(message: GetCandlesBulkRequestV2, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.requests) {
      GetCandlesRequestV2.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesBulkRequestV2 {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesBulkRequestV2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requests.push(GetCandlesRequestV2.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesBulkRequestV2 {
    return {
      requests: globalThis.Array.isArray(object?.requests)
        ? object.requests.map((e: any) => GetCandlesRequestV2.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCandlesBulkRequestV2): unknown {
    const obj: any = {};
    if (message.requests?.length) {
      obj.requests = message.requests.map((e) => GetCandlesRequestV2.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesBulkRequestV2>, I>>(base?: I): GetCandlesBulkRequestV2 {
    return GetCandlesBulkRequestV2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesBulkRequestV2>, I>>(object: I): GetCandlesBulkRequestV2 {
    const message = createBaseGetCandlesBulkRequestV2();
    message.requests = object.requests?.map((e) => GetCandlesRequestV2.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCandlesRequest(): GetCandlesRequest {
  return {
    security: undefined,
    timeBucket: undefined,
    referenceTime: 0,
    nextToken: "",
    numberOfCandles: 0,
    dontGiveExtraCandles: false,
  };
}

export const GetCandlesRequest = {
  encode(message: GetCandlesRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(18).fork()).ldelim();
    }
    if (message.referenceTime !== 0) {
      writer.uint32(24).int64(message.referenceTime);
    }
    if (message.nextToken !== "") {
      writer.uint32(34).string(message.nextToken);
    }
    if (message.numberOfCandles !== 0) {
      writer.uint32(40).int32(message.numberOfCandles);
    }
    if (message.dontGiveExtraCandles !== false) {
      writer.uint32(48).bool(message.dontGiveExtraCandles);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.referenceTime = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.nextToken = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.numberOfCandles = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.dontGiveExtraCandles = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesRequest {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      referenceTime: isSet(object.referenceTime) ? globalThis.Number(object.referenceTime) : 0,
      nextToken: isSet(object.nextToken) ? globalThis.String(object.nextToken) : "",
      numberOfCandles: isSet(object.numberOfCandles) ? globalThis.Number(object.numberOfCandles) : 0,
      dontGiveExtraCandles: isSet(object.dontGiveExtraCandles)
        ? globalThis.Boolean(object.dontGiveExtraCandles)
        : false,
    };
  },

  toJSON(message: GetCandlesRequest): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.referenceTime !== 0) {
      obj.referenceTime = Math.round(message.referenceTime);
    }
    if (message.nextToken !== "") {
      obj.nextToken = message.nextToken;
    }
    if (message.numberOfCandles !== 0) {
      obj.numberOfCandles = Math.round(message.numberOfCandles);
    }
    if (message.dontGiveExtraCandles !== false) {
      obj.dontGiveExtraCandles = message.dontGiveExtraCandles;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesRequest>, I>>(base?: I): GetCandlesRequest {
    return GetCandlesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesRequest>, I>>(object: I): GetCandlesRequest {
    const message = createBaseGetCandlesRequest();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.referenceTime = object.referenceTime ?? 0;
    message.nextToken = object.nextToken ?? "";
    message.numberOfCandles = object.numberOfCandles ?? 0;
    message.dontGiveExtraCandles = object.dontGiveExtraCandles ?? false;
    return message;
  },
};

function createBaseGetCandlesRequestV2(): GetCandlesRequestV2 {
  return {
    security: undefined,
    timeBucket: undefined,
    referenceTime: 0,
    forwardCandleCount: 0,
    backwardCandleCount: 0,
    dontGiveExtraCandles: false,
    dontApplyCorporateActionAdjustments: false,
  };
}

export const GetCandlesRequestV2 = {
  encode(message: GetCandlesRequestV2, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(18).fork()).ldelim();
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(34).fork()).ldelim();
    }
    if (message.referenceTime !== 0) {
      writer.uint32(48).int64(message.referenceTime);
    }
    if (message.forwardCandleCount !== 0) {
      writer.uint32(64).int32(message.forwardCandleCount);
    }
    if (message.backwardCandleCount !== 0) {
      writer.uint32(80).int32(message.backwardCandleCount);
    }
    if (message.dontGiveExtraCandles !== false) {
      writer.uint32(96).bool(message.dontGiveExtraCandles);
    }
    if (message.dontApplyCorporateActionAdjustments !== false) {
      writer.uint32(128).bool(message.dontApplyCorporateActionAdjustments);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesRequestV2 {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesRequestV2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.referenceTime = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.forwardCandleCount = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.backwardCandleCount = reader.int32();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.dontGiveExtraCandles = reader.bool();
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.dontApplyCorporateActionAdjustments = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesRequestV2 {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      referenceTime: isSet(object.referenceTime) ? globalThis.Number(object.referenceTime) : 0,
      forwardCandleCount: isSet(object.forwardCandleCount) ? globalThis.Number(object.forwardCandleCount) : 0,
      backwardCandleCount: isSet(object.backwardCandleCount) ? globalThis.Number(object.backwardCandleCount) : 0,
      dontGiveExtraCandles: isSet(object.dontGiveExtraCandles)
        ? globalThis.Boolean(object.dontGiveExtraCandles)
        : false,
      dontApplyCorporateActionAdjustments: isSet(object.dontApplyCorporateActionAdjustments)
        ? globalThis.Boolean(object.dontApplyCorporateActionAdjustments)
        : false,
    };
  },

  toJSON(message: GetCandlesRequestV2): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.referenceTime !== 0) {
      obj.referenceTime = Math.round(message.referenceTime);
    }
    if (message.forwardCandleCount !== 0) {
      obj.forwardCandleCount = Math.round(message.forwardCandleCount);
    }
    if (message.backwardCandleCount !== 0) {
      obj.backwardCandleCount = Math.round(message.backwardCandleCount);
    }
    if (message.dontGiveExtraCandles !== false) {
      obj.dontGiveExtraCandles = message.dontGiveExtraCandles;
    }
    if (message.dontApplyCorporateActionAdjustments !== false) {
      obj.dontApplyCorporateActionAdjustments = message.dontApplyCorporateActionAdjustments;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesRequestV2>, I>>(base?: I): GetCandlesRequestV2 {
    return GetCandlesRequestV2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesRequestV2>, I>>(object: I): GetCandlesRequestV2 {
    const message = createBaseGetCandlesRequestV2();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.referenceTime = object.referenceTime ?? 0;
    message.forwardCandleCount = object.forwardCandleCount ?? 0;
    message.backwardCandleCount = object.backwardCandleCount ?? 0;
    message.dontGiveExtraCandles = object.dontGiveExtraCandles ?? false;
    message.dontApplyCorporateActionAdjustments = object.dontApplyCorporateActionAdjustments ?? false;
    return message;
  },
};

function createBaseGetCandlesBulkResponse(): GetCandlesBulkResponse {
  return { responses: [] };
}

export const GetCandlesBulkResponse = {
  encode(message: GetCandlesBulkResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.responses) {
      GetCandlesResponse.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesBulkResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesBulkResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responses.push(GetCandlesResponse.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesBulkResponse {
    return {
      responses: globalThis.Array.isArray(object?.responses)
        ? object.responses.map((e: any) => GetCandlesResponse.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCandlesBulkResponse): unknown {
    const obj: any = {};
    if (message.responses?.length) {
      obj.responses = message.responses.map((e) => GetCandlesResponse.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesBulkResponse>, I>>(base?: I): GetCandlesBulkResponse {
    return GetCandlesBulkResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesBulkResponse>, I>>(object: I): GetCandlesBulkResponse {
    const message = createBaseGetCandlesBulkResponse();
    message.responses = object.responses?.map((e) => GetCandlesResponse.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCandlesBulkResponseV2(): GetCandlesBulkResponseV2 {
  return { responses: [] };
}

export const GetCandlesBulkResponseV2 = {
  encode(message: GetCandlesBulkResponseV2, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.responses) {
      GetCandlesResponseV2.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesBulkResponseV2 {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesBulkResponseV2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responses.push(GetCandlesResponseV2.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesBulkResponseV2 {
    return {
      responses: globalThis.Array.isArray(object?.responses)
        ? object.responses.map((e: any) => GetCandlesResponseV2.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCandlesBulkResponseV2): unknown {
    const obj: any = {};
    if (message.responses?.length) {
      obj.responses = message.responses.map((e) => GetCandlesResponseV2.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesBulkResponseV2>, I>>(base?: I): GetCandlesBulkResponseV2 {
    return GetCandlesBulkResponseV2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesBulkResponseV2>, I>>(object: I): GetCandlesBulkResponseV2 {
    const message = createBaseGetCandlesBulkResponseV2();
    message.responses = object.responses?.map((e) => GetCandlesResponseV2.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCandlesResponse(): GetCandlesResponse {
  return {
    security: undefined,
    timeBucket: undefined,
    referenceTime: 0,
    candles: [],
    nextToken: "",
    referencedSecurities: [],
  };
}

export const GetCandlesResponse = {
  encode(message: GetCandlesResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(18).fork()).ldelim();
    }
    if (message.referenceTime !== 0) {
      writer.uint32(24).int64(message.referenceTime);
    }
    for (const v of message.candles) {
      Candle.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.nextToken !== "") {
      writer.uint32(42).string(message.nextToken);
    }
    for (const v of message.referencedSecurities) {
      Security.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.referenceTime = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.candles.push(Candle.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.nextToken = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.referencedSecurities.push(Security.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesResponse {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      referenceTime: isSet(object.referenceTime) ? globalThis.Number(object.referenceTime) : 0,
      candles: globalThis.Array.isArray(object?.candles) ? object.candles.map((e: any) => Candle.fromJSON(e)) : [],
      nextToken: isSet(object.nextToken) ? globalThis.String(object.nextToken) : "",
      referencedSecurities: globalThis.Array.isArray(object?.referencedSecurities)
        ? object.referencedSecurities.map((e: any) => Security.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCandlesResponse): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.referenceTime !== 0) {
      obj.referenceTime = Math.round(message.referenceTime);
    }
    if (message.candles?.length) {
      obj.candles = message.candles.map((e) => Candle.toJSON(e));
    }
    if (message.nextToken !== "") {
      obj.nextToken = message.nextToken;
    }
    if (message.referencedSecurities?.length) {
      obj.referencedSecurities = message.referencedSecurities.map((e) => Security.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesResponse>, I>>(base?: I): GetCandlesResponse {
    return GetCandlesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesResponse>, I>>(object: I): GetCandlesResponse {
    const message = createBaseGetCandlesResponse();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.referenceTime = object.referenceTime ?? 0;
    message.candles = object.candles?.map((e) => Candle.fromPartial(e)) || [];
    message.nextToken = object.nextToken ?? "";
    message.referencedSecurities = object.referencedSecurities?.map((e) => Security.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCandlesResponseV2(): GetCandlesResponseV2 {
  return {
    security: undefined,
    timeBucket: undefined,
    forwardCandles: [],
    backwardCandles: [],
    lastCandleStoreUpdateTime: 0,
    referencedSecurities: [],
    corporateActions: [],
    companyEvents: [],
    newsArticles: [],
  };
}

export const GetCandlesResponseV2 = {
  encode(message: GetCandlesResponseV2, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.forwardCandles) {
      Candle.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.backwardCandles) {
      Candle.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    if (message.lastCandleStoreUpdateTime !== 0) {
      writer.uint32(56).int64(message.lastCandleStoreUpdateTime);
    }
    for (const v of message.referencedSecurities) {
      Security.encode(v!, writer.uint32(66).fork()).ldelim();
    }
    for (const v of message.corporateActions) {
      CorporateAction.encode(v!, writer.uint32(82).fork()).ldelim();
    }
    for (const v of message.companyEvents) {
      CompanyEventProto.encode(v!, writer.uint32(98).fork()).ldelim();
    }
    for (const v of message.newsArticles) {
      NewsArticle.encode(v!, writer.uint32(114).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetCandlesResponseV2 {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCandlesResponseV2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.forwardCandles.push(Candle.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.backwardCandles.push(Candle.decode(reader, reader.uint32()));
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.lastCandleStoreUpdateTime = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.referencedSecurities.push(Security.decode(reader, reader.uint32()));
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.corporateActions.push(CorporateAction.decode(reader, reader.uint32()));
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.companyEvents.push(CompanyEventProto.decode(reader, reader.uint32()));
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.newsArticles.push(NewsArticle.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCandlesResponseV2 {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      forwardCandles: globalThis.Array.isArray(object?.forwardCandles)
        ? object.forwardCandles.map((e: any) => Candle.fromJSON(e))
        : [],
      backwardCandles: globalThis.Array.isArray(object?.backwardCandles)
        ? object.backwardCandles.map((e: any) => Candle.fromJSON(e))
        : [],
      lastCandleStoreUpdateTime: isSet(object.lastCandleStoreUpdateTime)
        ? globalThis.Number(object.lastCandleStoreUpdateTime)
        : 0,
      referencedSecurities: globalThis.Array.isArray(object?.referencedSecurities)
        ? object.referencedSecurities.map((e: any) => Security.fromJSON(e))
        : [],
      corporateActions: globalThis.Array.isArray(object?.corporateActions)
        ? object.corporateActions.map((e: any) => CorporateAction.fromJSON(e))
        : [],
      companyEvents: globalThis.Array.isArray(object?.companyEvents)
        ? object.companyEvents.map((e: any) => CompanyEventProto.fromJSON(e))
        : [],
      newsArticles: globalThis.Array.isArray(object?.newsArticles)
        ? object.newsArticles.map((e: any) => NewsArticle.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCandlesResponseV2): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.forwardCandles?.length) {
      obj.forwardCandles = message.forwardCandles.map((e) => Candle.toJSON(e));
    }
    if (message.backwardCandles?.length) {
      obj.backwardCandles = message.backwardCandles.map((e) => Candle.toJSON(e));
    }
    if (message.lastCandleStoreUpdateTime !== 0) {
      obj.lastCandleStoreUpdateTime = Math.round(message.lastCandleStoreUpdateTime);
    }
    if (message.referencedSecurities?.length) {
      obj.referencedSecurities = message.referencedSecurities.map((e) => Security.toJSON(e));
    }
    if (message.corporateActions?.length) {
      obj.corporateActions = message.corporateActions.map((e) => CorporateAction.toJSON(e));
    }
    if (message.companyEvents?.length) {
      obj.companyEvents = message.companyEvents.map((e) => CompanyEventProto.toJSON(e));
    }
    if (message.newsArticles?.length) {
      obj.newsArticles = message.newsArticles.map((e) => NewsArticle.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCandlesResponseV2>, I>>(base?: I): GetCandlesResponseV2 {
    return GetCandlesResponseV2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCandlesResponseV2>, I>>(object: I): GetCandlesResponseV2 {
    const message = createBaseGetCandlesResponseV2();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.forwardCandles = object.forwardCandles?.map((e) => Candle.fromPartial(e)) || [];
    message.backwardCandles = object.backwardCandles?.map((e) => Candle.fromPartial(e)) || [];
    message.lastCandleStoreUpdateTime = object.lastCandleStoreUpdateTime ?? 0;
    message.referencedSecurities = object.referencedSecurities?.map((e) => Security.fromPartial(e)) || [];
    message.corporateActions = object.corporateActions?.map((e) => CorporateAction.fromPartial(e)) || [];
    message.companyEvents = object.companyEvents?.map((e) => CompanyEventProto.fromPartial(e)) || [];
    message.newsArticles = object.newsArticles?.map((e) => NewsArticle.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
